module.exports = __webpack_public_path__ + "static/media/panel-fee.3f1db8f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/schedule/panel-fee.png
// module id = 2043
// module chunks = 6